import {linkPlayerToAccount} from '@/api/api';
import {logLogoutEvent} from '../common/analytics-events';
import {auth as fireBaseAuth} from './config';

export async function simpleLogout(reason?: string) {
  await silentLogout();
  window.location.replace(`/auth${reason ? '?reason=' + reason : ''}`);
}

export async function silentLogout() {
  await fireBaseAuth.signOut();
  localStorage.clear();
  logLogoutEvent();
}

export async function handlePostSignUp(userCredential: any): Promise<string> {
  const isNewAccount = userCredential._tokenResponse.isNewUser;
  const route = '/home';
  if (isNewAccount) {
    await linkPlayerToAccount();
  }

  return route;
}
